// src/pages/DevFixClaims.jsx
import React, { useState } from 'react';
import { Box, Button, Heading, HStack, Input, Text, VStack, useToast } from '@chakra-ui/react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';

export default function DevFixClaims() {
  const toast = useToast();
  const [orgId, setOrgId] = useState('');
  const [busy, setBusy] = useState(false);

  const setMyClaims = async () => {
    const user = getAuth().currentUser;
    if (!user) {
      toast({ title: 'Please sign in first', status: 'warning' });
      return;
    }
    if (!orgId.trim()) {
      toast({ title: 'Enter your orgId', status: 'warning' });
      return;
    }

    try {
      setBusy(true);
      const fn = getFunctions(undefined, 'europe-west2');
      const call = httpsCallable(fn, 'setMyClaimsFromMembership');
      const res = await call({ orgId: orgId.trim() });
      await user.getIdToken(true); // refresh token so rules see new claims
      toast({
        title: 'Claims set',
        description: `Org: ${res.data.orgId}, role: ${res.data.role}`,
        status: 'success',
      });
    } catch (e) {
      toast({
        title: 'Failed to set claims',
        description: String(e.message || e),
        status: 'error',
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box p={6}>
      <VStack align="start" spacing={4}>
        <Heading size="md">Dev: Set My Claims From Membership</Heading>
        <Text>
          Paste your orgId (e.g. <code>65lzXE2tgxdqZjgLsCIn</code>) and click the button.
        </Text>
        <HStack>
          <Input
            placeholder="orgId"
            value={orgId}
            onChange={(e) => setOrgId(e.target.value)}
            width="420px"
          />
          <Button colorScheme="blue" onClick={setMyClaims} isLoading={busy}>
            Set my claims
          </Button>
        </HStack>
        <Text fontSize="sm" color="gray.500">
          One-time helper for local dev only.
        </Text>
      </VStack>
    </Box>
  );
}
